export enum LanguageCodesEnum {
  En = 'en',
  Fr = 'fr',
  De = 'de',
  It = 'it',
  Pt = 'pt',
  Es = 'es',
}
